<template>
    <div class="trend-container">
        <div class="trend-title">
            {{ $t('LEAGUE_TREND') }}
        </div>
        
        <template v-if="data.homeOdds?.isReady && data.awayOdds?.isReady">
            <div class="tab1-list">
                <div v-for="(o, i1) in tab1" :key="i1"
                    class="tab1-item"
                    :class="{
                        'selected': o.selected
                    }"
                    @click="handleTab1(o)">
                    {{ $t(o.name) }}
                </div>
            </div>
        
            <div class="tab2-list nav-pill__wrapper">
                <div v-for="(o, i1) in tab2" :key="i1" class="nav-pill btn-aspn-default tab2-item"
                    :class="{
                        'selected': o.selected
                    }"
                    @click="handleTab2(o)">
                    {{ $t(o.name) }}
                </div>
            </div>
    
    
            <div class="circe-progress-list" >
                <!-- circle progress -->
                <div class="display-flex-center w-100 circle-progress-item-box" 
                    v-for="(i, index) in circleProgressLabel[tabSelected]">
                    <template v-if="i.key === 'last6' && tabSelected === 'handicap'">
                        <div class="circle-result result-home" v-if="i.key === 'last6'">
                            {{ `${data.homeOdds[tabSelected]['full']['last6']['win']}/${data.homeOdds[tabSelected]['full']['last6']['match']}` }}
                        </div>
    
                        <div class="progress-circle circle-home" 
                            :style="`--progress:${data.homeOdds[tabSelected]['full']['last6']['winRate']}`" 
                            :data-progress="data.homeOdds[tabSelected]['full']['last6']['winRate']">
                        </div>
                        
                        <div class="circle-progress-title">
                            {{ $t(i.name) }}
                        </div>
        
                        <div class="progress-circle circle-away" 
                        :style="`--progress:${data.awayOdds[tabSelected]['full']['last6']['winRate']}`" 
                            :data-progress="data.awayOdds[tabSelected]['full']['last6']['winRate']">
                        </div>
    
                        <div class="circle-result result-away">
                            {{ `${data.awayOdds[tabSelected]['full']['last6']['win']}/${data.awayOdds[tabSelected]['full']['last6']['match']}` }}
                        </div>
    
                    </template>
                    <template v-else>
                        <div class="circle-result result-home">
                            {{ `${data.homeOdds[tabSelected]['full'][tab2Selected][i.keyName]}/${data.homeOdds[tabSelected]['full'][tab2Selected]['match']}` }}
                        </div>
        
                        <div class="progress-circle circle-home" 
                            :style="`--progress:${data.homeOdds[tabSelected]['full'][tab2Selected][i.key]}`" 
                            :data-progress="data.homeOdds[tabSelected]['full'][tab2Selected][i.key]">
                        </div>
                        
                        <div class="circle-progress-title">
                            {{ $t(i.name) }}
                        </div>
        
                        <div class="progress-circle circle-away" 
                        :style="`--progress:${data.awayOdds[tabSelected]['full'][tab2Selected][i.key]}`" 
                            :data-progress="data.awayOdds[tabSelected]['full'][tab2Selected][i.key]">
                        </div>
                        <div class="circle-result result-away">
                            {{ `${data.awayOdds[tabSelected]['full'][tab2Selected][i.keyName]}/${data.awayOdds[tabSelected]['full'][tab2Selected]['match']}` }}
                        </div>
                    </template>
    
                </div>
                <div class="last-6-list">
                    <div class="last-6-item">
                        <div class="last-6-child" 
                            :class="i"
                            :key="index"
                            v-for="(i,index) in data.homeOdds[tabSelected]['full']['last6']['last6Arr']">
                            {{ i }}
                        </div>
                    </div>
                    <div class="last-6-item">
                        <div class="last-6-child" 
                            :class="i"
                            :key="index"
                            v-for="(i,index) in data.awayOdds[tabSelected]['full']['last6']['last6Arr']">
                            {{ i }}
                        </div>
                    </div>
                    <!-- {{ data.homeOdds[tabSelected]['full']['last6']['last6Arr'] }} -->
                </div>
            </div>
        </template>
        <template v-else>
            <NoData />
        </template>
        
    </div>


    
</template>

<script>
    import { mapActions } from 'vuex';
    export default {
        name: 'LeagueTrend',
        data() {
            return {
                circleProgressLabel: {
                    handicap: [
                        {
                            name: "WIN",
                            key: 'winRate',
                            keyName: 'win'
                        },
                        {
                            name: "DRAW",
                            key: 'drawRate',
                            keyName: 'draw'
                        },
                        {
                            name: "LOSE",
                            key: 'loseRate',
                            keyName: 'lose'
                        },
                        {
                            name: "LAST_6_WIN",
                            key: 'last6'
                        }
                    ],
                    goals: [
                    {
                            name: "BIG_BALL",
                            key: 'bigBallRate',
                            keyName: 'bigBall'
                        },
                        {
                            name: "SMALL_BALL",
                            key: 'smallBallRate',
                            keyName: 'smallBall'
                        },
                    ]
                },
                tab1: [
                    {
                        name: 'HANDICAP',
                        key: 'handicap',
                        selected: true,
                    },
                    {
                        name: 'GOALS',
                        key: 'goals',
                        selected: false,
                    }
                ],
                tab2: [
                    {
                        name: 'TOTAL',
                        key: 'total',
                        selected: true,
                    },
                    {
                        name: 'HOME',
                        key: 'home',
                        selected: false,
                    },
                    {
                        name: 'AWAY',
                        key: 'away',
                        selected: false,
                    }
                ],
                tabSelected: "handicap",
                tab2Selected: "total",
                data: {},
                homeTeam: "",
                awayTeam: "",
                homeTotalGoalScore: "",
                awayTotalGoalScore: "",
                homeHalfTime: "",
                awayHalfTime: "",
                homeShootTime: "",
                awayShootTime: "",
                homeOdds: "",
                awayOdds: "",
            }
        },
        props: {
            matchDetailScore: Object
        },
        mounted() {
            this.getGoalScoringStatsData()
        },
        methods: {
            ...mapActions(["getGoalScoringStats"]),
            async getGoalScoringStatsData() {
            
                const result = await this.getGoalScoringStats({ matchId: this.$route.params.matchId });
                // this.isLoading = false;

                this.dataValidation(result.result);
            },
            dataValidation(data) {
                // this.homeTeam = {
                //     team: "homeTeam",
                //     name: this.matchDetailScore.homeTeamName,
                // };
                // this.awayTeam = {
                //     team: "awayTeam",
                //     name: this.matchDetailScore.awayTeamName,
                // };

                if (data.homeTotalGoalScore) {
                    this.homeTotalGoalScore = eval(data.homeTotalGoalScore);
                }
                if (data.awayTotalGoalScore) {
                    this.awayTotalGoalScore = eval(data.awayTotalGoalScore);
                }
                if (data.homeHalfTime) {
                    this.homeHalfTime = eval(data.homeHalfTime);
                }
                if (data.awayHalfTime) {
                    this.awayHalfTime = eval(data.awayHalfTime);
                }
                if (data.homeShootTime) {
                    this.homeShootTime = eval(data.homeShootTime);
                }
                if (data.awayShootTime) {
                    this.awayShootTime = eval(data.awayShootTime);
                }
                if (data.homeOdds) {
                    this.homeOdds = eval(data.homeOdds);
                    this.data['homeOdds'] = this.initOdds(eval(data.homeOdds))
                    this.data['homeOdds']['isReady'] = true
                }
                if (data.awayOdds) {
                    this.awayOdds = eval(data.awayOdds);
                    this.data['awayOdds'] = this.initOdds(eval(data.awayOdds))
                    this.data['awayOdds']['isReady'] = true
                }
            },
            initOdds(list) {
                const rowTitle = ["handicap", "goals"] // split handicap and goals
                const rowListKey = ['full','full','full','full','half','half','half','half'] // split full and half
                const columnTitle = ["total","home","away","last6","total","home","away","last6"] // list index = title name
                const rowKey = ["match","win","draw","lose","winRate","bigBall","bigBallRate","smallBall","smallBallRate"] // row index = data name
                const calc = ["draw","lose"] // need calc and add %
                const lastSixKeyIndex = ['3','7'] // other calc
                var data = {}
                
                for(var index in rowTitle) {
                    const rowTitleValue = rowTitle[index]
                    if(!data[rowTitleValue]) {
                        data[rowTitleValue] = {}
                    }
                    const dataRow = data[rowTitleValue]                    
                    
                    // ----------------------------------------------
                    for(var index2 in columnTitle) {
                        const rowListKeyValue = rowListKey[index2]
                        if(!dataRow[rowListKeyValue]) {
                            dataRow[rowListKeyValue] = {}
                        }
                        const dataRowList = dataRow[rowListKeyValue]
                        const columnTitleValue = columnTitle[index2]
                        if(!dataRowList) {
                            dataRowList[columnTitleValue] = {}
                        }
                    }

                    // ----------------------------------------------
                    for(var index3 in list) {
                        // rowTitleValue
                        let rowListKeyValue = rowListKey[index3] // full/half
                        let columnKeyValue = columnTitle[index3] // total/win....
                        if(!dataRow[rowListKeyValue][columnKeyValue]) {
                            dataRow[rowListKeyValue][columnKeyValue] = {}
                        }
                        
                        // ----------------------------------------------
                        if(!lastSixKeyIndex.includes(index3)) {
                            let data = this.calcWinLose(list[index3])
                            for(var index4 in list[index3]) {
                                let listItemKey = rowKey[index4]
                                let listItem = list[index3][index4]
                                dataRow[rowListKeyValue][columnKeyValue][listItemKey] = listItem
                                Object.assign(dataRow[rowListKeyValue][columnKeyValue], data)
                            }
                        } 
                        
                        // ----------------------------------------------
                        else { // last 6 
                            if(rowTitleValue === 'handicap') {
                                let data = this.calcLast6WinLose(list[index3][0], list[index3][1])
                                let obj = {
                                    match: list[index3][0],
                                    win: data.win,
                                    lose: data.lose,
                                    draw: data.draw,
                                    winRate: data.winRate,
                                    last6Arr: data.last6Arr
                                }
                                dataRow[rowListKeyValue]['last6'] = obj
                            }
                            else if(rowTitleValue === 'goals') {
                                let data = this.calcBigSmall(list[index3][3])
                                let obj = {
                                    match: list[index3][0],
                                    big: data.big,
                                    small: data.small,
                                    winRate: data.winRate,
                                    last6Arr: data.last6Arr
                                }
                                dataRow[rowListKeyValue]['last6'] = obj
                            }
                            
                        }

                    }

                    


                }
                
                return data

            },
            calcWinLose(data) {
                let total = data[0]
                let winRate = data[4]
                let drawRate = ((data[2] / total) * 100).toFixed(0) + '%'
                let loseRate = ((data[3] / total) * 100).toFixed(0) + '%'
                return {
                    winRate,
                    drawRate,
                    loseRate
                }
            },
            calcLast6WinLose(total, data) {
                // 0 lose
                // 1 draw
                // 2 win
                let win = 0;
                let draw = 0;
                let lose = 0
                let last6Arr = []
                for(var index in data) {
                    if(data[index] === '0') {
                        lose++
                        last6Arr.push('L')
                    } else if(data[index] === '1') {
                        draw++
                        last6Arr.push('D')
                    } else {
                        win++
                        last6Arr.push('W')
                    }
                }

                let winRate = ((win / total) * 100).toFixed(0) + `%`;
                let drawRate = ((draw / total) * 100).toFixed(0) + `%`;
                let loseRate = ((lose / total) * 100).toFixed(0) + `%`;
                
                return {
                    win,
                    draw,
                    lose,
                    winRate,
                    drawRate,
                    loseRate,
                    last6Arr
                }
            },
            calcBigSmall(data) {
                // 0 small
                // 2 big
                let total = 6
                let small = 0;
                let big = 0
                let last6Arr = []
                for(var index in data) {
                    if(data[index] === '0') {
                        small++
                        last6Arr.push('S')
                    } else if(data[index] === '2') {
                        big++
                        last6Arr.push('B')
                    }
                }
                let winRate = ((big / total) * 100).toFixed(0) + `%`;
                return {
                    big,
                    small,
                    winRate,
                    last6Arr
                }
            },
            handleTab1(o) {
                this.tab1.forEach(x => {
                    x.selected = false;
                })
                o.selected = true;
                this.tabSelected = o.key

                this.tab2.forEach(x => {
                    x.selected = false;
                })
                this.tab2[0].selected = true;
                this.tab2Selected = this.tab2[0].key
            },
            handleTab2(o) {
                this.tab2.forEach(x => {
                    x.selected = false;
                })
                o.selected = true;
                this.tab2Selected = o.key
            },
        }
    }
</script>

<style scoped>
.trend-container {
    padding: 16px 8px 26px;
    box-sizing: border-box;
    background-color: var(--color-background-default-secondary);
    /* margin-bottom: 16px; */
    border-radius: 8px;
    border-top: 1px dashed var(--color-border-default-default);
    margin-top: 16px;
}
.trend-title {
    font-size: 24px;
    text-align: center;
    font-family: var(--weight-600);
    margin-bottom: 16px;
    color: var(--color-text-default-default);
}
.tab1-list {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    margin-bottom: 16px;
}
.tab1-item {
    display: flex;
    align-items: center;
    font-family: var(--weight-600);
    font-size: 16px;
    gap: 8px;
    padding: 16px 8px 8px;
    /* margin: 0 8px; */
    white-space:nowrap; 
    overflow:hidden; 
    text-overflow:ellipsis;
    letter-spacing: .64px;
    color: var(--color-text-default-default);
}
.tab1-item.selected {
    position: relative;
}
.tab1-item.selected:after {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 2px;
    border-radius: 2px;
    background-color: var(--primary-500);
    content: '';
    display: block;
}
.tab2-list {
    padding: 8px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    margin-bottom: 16px;
}
.tab2-item {
    /* flex: 1; */
    height: 34px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    margin-right: 0;
    border-radius: 17px;
    padding: 8px 24px;
}
.trend-item-box {
  position: relative;
}

.circle-progress-item-box {
    
  color: var(--color-text-default-default);
  margin: 0 0 1rem 0;
}
.progress-circle {
    width: 64px;
    height: 64px;
    /* background: conic-gradient(#4DB761 0% var(--progress), var(--color-background-default-default) var(--progress) 100%); */
    /* background: conic-gradient(green 70%, #f1f1f1 30%); */
    border-radius: 50%;
    position: relative;
    transform: rotateY(180deg); /* 让起点变为顶部 */
}
.progress-circle.circle-home {
    background: conic-gradient(#4DB761 0% var(--progress), var(--color-background-default-default) var(--progress) 100%);

}
.progress-circle.circle-away {
    background: conic-gradient(#26B3FF 0% var(--progress), var(--color-background-default-default) var(--progress) 100%);
}
.progress-circle:after {
    position: absolute;
    top: 7px;
    left: 7px;
    width: 50px;
    height: 50px;
    background-color: var(--color-background-default-secondary);
    display: block;
    content: attr(data-progress);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    transform: rotateY(180deg); /* 让起点变为顶部 */
    font-size: 16px;
    font-family: var(--weight-600);

}
.circle-progress-title {
    width: 270px;
    text-align: center;
    font-size: 16px;
    font-family: var(--weight-400);
    padding: 0 16px;
    box-sizing: border-box;
}
.circle-result {
    width: 40px;
    text-align: center;
    font-size: 14px;
}
.result-home {
    margin-right: 4px;
}
.result-away {
    margin-left: 4px;
}

.last-6-list {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0;
    padding-top: 3.3px;
}
.last-6-item {
    display: flex;
    align-items: center;
    padding: 0 36px;
    gap: 6.66px;
    
}
.last-6-child {
    width: 33.33px;
    height: 33.33px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--color-button-active);
    position: relative;
    font-family: var(--weight-600);
    font-size: 16px;
}
.last-6-child.L {
    background-color: var(--error-500);
}
.last-6-child.B,
.last-6-child.W {
    background-color: var(--primary-500);
}
.last-6-child.S,
.last-6-child.D {
    background-color: var(--gray-500);
}
.last-6-child:last-child:after {
    position: absolute;
    bottom: -6.33px;
    left: 15%;
    width: 70%;
    height: 3.33px;
    border-radius: 2px;
    display: block;
    content: "";
}
.last-6-child.L:after {
    background-color: var(--error-500);
}
.last-6-child.B:after,
.last-6-child.W:after {
    background-color: var(--primary-500);
}
.last-6-child.S:after,
.last-6-child.D:after {
    background-color: var(--gray-500);
}

@media(max-width: 768px) {
.trend-container {
    border-top: 0;
    margin-top: 0;
}
.tab2-item {
    flex: 1;
    padding: 8px 16px;
}
.circle-progress-title {
    width: 120px;
}
.progress-circle:after {
    font-size: 14px;
}
.last-6-list {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 47px;
    padding-top: 3.3px;
}
.last-6-item {
    display: grid;
    grid-template-columns: repeat(3, 33.33%);
    align-items: center;
    padding: 0 15.33px;
    gap: 6.66px;
    
}
.last-6-child {
    font-size: 14px;
}
}
</style>